import { Control, Controller, useWatch } from 'react-hook-form';
import { Toggle } from 'rsuite';
import { Skeleton } from '../../../../../../components/Skeleton';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';
import { FormValues } from '../interfaces';
import { OutlierPercentageInput } from './OutlierPercentageInput';

type OutliersSectionProps = {
  control: Control<FormValues>;
  isLoading?: boolean;
};

const DESCRIPTION =
  'Preços de concorrentes com variação muito alta em relação ao seu preço vigente são descartados pelo IPA. ' +
  'Um preço classificado como outlier não entra na precificação do produto, não aparece no Gerenciador e não influencia nenhum cálculo. ' +
  'Use os limites abaixo para definir o que conta como variação muito alta.';

export const OutliersSection = ({ control, isLoading = false }: OutliersSectionProps) => {
  const active = useWatch({ control, name: 'outlier_config.active' });

  return (
    <div className={styles['setup-ipa__price-preference-competitor']}>
      <SetupIPAHeader title="Tratamento de outliers" subtitle={DESCRIPTION} />

      {isLoading ? (
        <div className={styles['outliers-skeleton']} aria-label="Carregando configurações de outliers">
          <Skeleton width={180} height={20} />
          <Skeleton width={200} height={36} />
          <Skeleton width={200} height={36} />
        </div>
      ) : (
        <>
          <Controller
            name="outlier_config.active"
            control={control}
            render={({ field }) => (
              <div className={styles['outliers-toggle']}>
                <Toggle aria-labelledby="outliers-toggle-label" size="sm" checked={field.value} onChange={field.onChange} />
                <span id="outliers-toggle-label">Usar filtro de outliers</span>
              </div>
            )}
          />

          {active && (
            <div className={styles['outliers-inputs']}>
              <Controller
                name="outlier_config.max_limit"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <OutlierPercentageInput
                    id="outliers-upper-limit"
                    label="Limite superior"
                    description="Quanto o preço do concorrente pode ficar acima do seu preço vigente. Descartamos quem passar dessa %."
                    value={field.value}
                    error={error?.message}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                  />
                )}
              />
              <Controller
                name="outlier_config.min_limit"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <OutlierPercentageInput
                    id="outliers-lower-limit"
                    label="Limite inferior"
                    description="Quanto o preço do concorrente pode ficar abaixo do seu preço vigente. Descartamos quem passar dessa %."
                    value={field.value}
                    error={error?.message}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                  />
                )}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
